<template>
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar :title="setTitle" custom-class="timeline-back-button" ></NavBar>

       
        <!-- Content -->
        <div class="container pt-0 px-0" v-if="itemsToShow">


            <div class="d-flex align-items-center filter-container">
                <Filters @change="filterTitleChange($event)" @updateModal="setMoaModalByEvent" @itemsChange="setGrids"></Filters>
                <div v-if="moaModal" class="moaButton">
                    <button type="button" class="btn btn-outline-primary" data-toggle="modal" data-target="#moa-modal" @click="trackMoaModal()">
                        <span class="d-flex align-items-center justify-content-center button-span">
                            <span class="mr-1 ml-auto">MoA</span>
                            <svg class="ml-auto" height="16px" aria-hidden="true" focusable="false" data-prefix="fas"
                                 data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                <path fill="#00bcff"
                                    d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                                class=""></path>
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <Moa-modal :product="moaModal" class="moa-button"></Moa-modal>
            <div class="timeline-shell">
            <div class="timeline" ref="timelineEl" @scroll="syncTimelineScrollbar">
                    <div class="timeline-track">
                    <div class="timeline-group"
                         :class="currentYear === yearData.year ? 'group-is-current-year' :'' "
                         v-for="yearData in timelineItemsComputed"
                         :key="yearData.year"
                         :id="'timeline-group-' + yearData.year +''"
                    >
                        <h2 class="text-center timeline-title">{{ yearData.year}}</h2>

                        <div class="timeline-year" :class="'timeline-year-' + yearData.year + ''" >
                            <ul class="month-list" :class="currentYear === yearData.year ? 'is-current-year' :'' ">
                                <li v-for="(monthData, monthIndex) in yearData.data"
                                    class="month-list__month"
                                    :class="currentYear === yearData.year ? 'month-display': '' "
                                    :data-month="currentYear === yearData.year ? months[(monthData.month - 1)] : '' "
                                    :key="monthIndex"
                                >

                                    <div class="month-list__container" :class="'grid-month-' + monthData.month +''">

                                        <div class="month-list__grid"  :class="setClassName(monthData.month)">
                                            <template v-for="(dayData, dayIndex) in monthData.data">

                                                <div :class="'grid-day-' + dayData.day + ''" class="grid-day" :key="dayIndex">
                                                    <ul class="items-list">
                                                        <li v-for="item in dayData.data"
                                                            :data-reverseContent="item.positionIndex"
                                                            :data-phase="getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value')"
                                                            :data-product="getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value')"
                                                            class="timeline-item"
                                                            :data-node-id="item.nid[0].value"
                                                            :class="getDiseaseStateClassName( (item.field_disease_state_tag.length ? item.field_disease_state_tag[0].target_id : '')) | toClassName"
                                                            :data-diseasestate="getDiseaseState( (item.field_disease_state_tag.length ? item.field_disease_state_tag : ''), 'name', 'value')"
                                                            :key="item.nid[0].value"
                                                        >
                                                            <div class="timeline-content">
                                                                <router-link :to="getlink(item.nid[0].value)"
                                                                             @click.native="trackEvent"
                                                                             data-category="Timeline Navigation"
                                                                             data-action="button_press"
                                                                             :data-event="getTrackingLabelData(item)"
                                                                >
                                                                    <img :src="setImagePath(item.field_trial_logo[0].url)" class="timeline-logo">
                                                                    <p class="phase">{{ getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value') }}</p>
                                                                    <h2>
                                                                        {{ getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value') }}
                                                                    </h2>
                                                                </router-link>
                                                            </div>
                                                            <span class="count">
                                                                <img src="img/ui-elements/timeline-user.png" class="user-icon" />
                                                                {{item.field_number_of_participants[0].value }}
                                                            </span>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="timeline-end-spacer"></div>
                    </div>
            </div>
            <div
                class="timeline-h-scroll"
                ref="timelineHScroll"
                role="scrollbar"
                aria-label="Timeline"
                aria-orientation="horizontal"
                :aria-valuenow="timelineScrollPercent"
                aria-valuemin="0"
                aria-valuemax="100"
                @mousedown.prevent="onScrollbarPointerDown"
                @touchstart.prevent="onScrollbarPointerDown"
            >
                <div class="timeline-h-scroll-thumb" :style="timelineThumbStyle"></div>
            </div>
            </div>

            <Approval v-if="this.isIpad" timeline="timeline-approval"></Approval>

            <!-- Legend -->
            <ul class="timeline-legend">
                <li class="venous-protection" v-if="legendItems.indexOf('venous-protection') > -1">Venous protection</li>
                <li class="vascular-protection" v-if="legendItems.indexOf('vascular-protection') > -1">Vascular protection</li>
                <li class="stroke-prevention" v-if="legendItems.indexOf('stroke-prevention') > -1">Stroke prevention</li>
                <li class="cardiorenal" v-if="legendItems.indexOf('cardiorenal') > -1">CardioRenal</li>
            </ul>
        </div>
        <div v-else class="container">
            <div class="alert alert-danger" role="alert">
                There are no available products. 
             </div>
        </div>

        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline.png" class="bottom-center">
        </div>

        <Disclaimer timeline="true"></Disclaimer>
        <ReusableDisclaimer :params="disclaimerParams" @accepted="onAccepted"></ReusableDisclaimer>
    </div>
</template> 

<script>

    import NavBar from './components/NavBar'; 
    import Filters from './components/Filters'; 
    import getTaxonomyData from './components/getTaxonomyData'; 
    import Disclaimer from './components/DisclaimerModal.vue'; 
    import Approval from './components/Approval.vue';
    import MoaModal from './components/MoaModal.vue';
    import ReusableDisclaimer from './components/ReusableDisclaimerModal.vue';

    export default {
        extends: getTaxonomyData,
        name: 'Timeline',
        data: function() {
            return {
                legendItems: [],
                pageTitle: false,
                itemsToShow: true,
                vm: this,
                styleProp: '',
                moaModalProduct: false,
                shortMonth: [
                    2,
                ],
                middleMonth: [
                    9, 4, 6, 11
                ],
                months: [
                    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep',
                    'oct', 'nov', 'dec'
                ],
                checkCache: false,
                intersectionOb: '',
                todayInView: false,
                disclaimerParams: null,
                timelineMetrics: {
                    scrollLeft: 0,
                    scrollWidth: 1,
                    clientWidth: 1,
                    trackWidth: 1
                },
            }
        },
        components: {
            NavBar,
            Filters,
            Disclaimer,
            Approval,
            MoaModal,
            ReusableDisclaimer,
        },
        filters: {
            toClassName: function(str) {
                let s = str.replace(' ', '-');
                return s.toLowerCase();
            },
        },
        created: async function() {
            this.setMoaModal();
        },
        mounted: async function(){
            window.grid = this;
            let logos = this.$store.getters.getTrialImages;
            try {
                if (logos.length > 0) {
                    await this.$imagePreload(logos);
                }
            } catch (e) {
                // pass
            }
            document.body.classList.add('timeline-page');
            this._sizeTimeline = this.sizeTimeline.bind(this);
            this.sizeTimeline();
            this.syncTimelineScrollbar();
            window.addEventListener('resize', this._sizeTimeline);
            window.addEventListener('orientationchange', this._sizeTimeline);
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', this._sizeTimeline);
            }
            this.bindTimelinePan();
            this.setToday();

            if (!this.isIpad) {
                this.generateDisclaimerContent();
            }
        },
        beforeDestroy: function() {
            this.clearTodaySnap();
            this.unbindScrollbarPointer();
            window.removeEventListener('resize', this._sizeTimeline);
            window.removeEventListener('orientationchange', this._sizeTimeline);
            if (window.visualViewport && this._sizeTimeline) {
                window.visualViewport.removeEventListener('resize', this._sizeTimeline);
            }
            this.unbindTimelinePan();
            document.body.classList.remove('timeline-page');
        },
        watch: {
            '$route' (to) {
                if(to.path == '/timeline') {
                    window.location.reload();
                }
            },
        },
        computed: {
            moaModal() {
                return this.moaModalProduct;
            },
            approval() {return this.$store.getters.getApproval},
            products() {
                return this.$store.getters.allProducts;
            },
            timelineItems() { return this.filterItemsByDate() },
            setTitle(){ return this.pageTitle ? this.pageTitle : ( (this.$route.params.filtertype == undefined) || (this.$route.params.filtertype == 'diseasestate' || this.$route.params.filtertype == 'all') ? (window.localStorage.getItem('appHomepageStatus') !== null ? 'Data Navigator' : '') : this.$route.params.filtervalue) },
            timelineThumbStyle: function() {
                const metrics = this.timelineMetrics;
                const overflow = Math.max(metrics.scrollWidth - metrics.clientWidth, 0);
                const track = Math.max(metrics.trackWidth, 1);
                const thumbWidth = overflow < 1
                    ? track
                    : Math.max(48, (metrics.clientWidth / metrics.scrollWidth) * track);
                const maxLeft = Math.max(track - thumbWidth, 0);
                const left = overflow < 1 || maxLeft < 1
                    ? 0
                    : (metrics.scrollLeft / overflow) * maxLeft;
                return {
                    width: Math.round(thumbWidth) + 'px',
                    transform: 'translateX(' + Math.round(left) + 'px)'
                };
            },
            timelineScrollPercent: function() {
                const metrics = this.timelineMetrics;
                const overflow = Math.max(metrics.scrollWidth - metrics.clientWidth, 0);
                if (overflow < 1) {
                    return 0;
                }
                return Math.round((metrics.scrollLeft / overflow) * 100);
            },
            timelineItemsComputed(){ 
                let count = 0;
                
                for(var i=0; i < this.timelineItems.length; i++)
                {
                    for(var j = 0; j < this.timelineItems[i].data.length; j++){
                        for(var k = 0; k < this.timelineItems[i].data[j].data.length; k++){
                            for(var l = 0; l < this.timelineItems[i].data[j].data[k].data.length; l++) {
                                // eslint-disable-next-line
                                this.timelineItems[i].data[j].data[k].data[l].positionIndex = (count % 2) !== 0 ? 'reverseContent' : ''; 
                                count++;
                            }
                        }
                    }
                }
                return this.timelineItems; 
            },
            currentYear: function(){
                let d = new Date();
                return d.getFullYear();
            },

        },
        methods: {
            generateDisclaimerContent: function() {
                const source = this.$route.params.filtervalue || 'see_all';
                this.disclaimerParams = this.getDisclaimerContent(source);
            },
            getDisclaimerContent: function(source) {
                const title = this.$route.params.filtertype || 'see_all';
                const sourceMap = {
                    'product': () => this.getProductDisclaimer(source),
                    'diseasestate': () => this.getDiseaseStateDisclaimer(source),
                    'see_all': () => this.getSeeAllDisclaimer(source),
                };
                return sourceMap[title] ? sourceMap[title]() : this.disclaimers[title.toLowerCase()];
            },
            getProductDisclaimer: function(productName) {
                const productNames = this.$store.getters.getProductNames;
                const product = productNames.filter(item => item.title[0].value === productName);
                let data = null;
                if (product && product[0].field_product_disclaimer.length > 0) {
                    data = {
                        id: productName.toLowerCase(),
                        title: 'Disclaimer',
                        body: product[0].field_product_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            getDiseaseStateDisclaimer: function(stateName) {
                const event = this.$store.getters.getEvent;
                let data = null;
                if (event && 
                    event.field_disease_state_disclaimer.length > 0 &&
                    event.field_event_is_live_[0].value === 'Yes'
                ) {
                    data = {
                        id: stateName.toLowerCase(),
                        title: 'Disclaimer',
                        body: event.field_disease_state_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            getSeeAllDisclaimer: function() {
                const event = this.$store.getters.getEvent;
                let data = null;
                if (event && 
                    event.field_timeline_disclaimer.length > 0 &&
                    event.field_event_is_live_[0].value === 'Yes'
                ) {
                    data = {
                        id: 'see_all',
                        title: 'Disclaimer',
                        body: event.field_timeline_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            trackMoaModal: function() {
                if (this.moaModalProduct) {
                    this.$root.track('callback://screenname_MOA - ' + this.moaModalProduct);
                }
                this.analytics.trackGoal(
                    this.$router.currentRoute.path,
                    'MoA Modal',
                    'moa_modal'
                );
            },
            setGrids: function(action) {
                if(action) {
                    document.querySelector('.month-list.is-current-year').classList.remove('small-grid');
                    return false;
                }
                let legendItems = [];
                let currentYear = document.querySelector('.month-list.is-current-year');
                currentYear.classList.remove('small-grid');
                let itemsList = currentYear.querySelectorAll('.items-list li');
                let allItemsList = document.querySelectorAll('.items-list li');

                [].slice.call(allItemsList).forEach(function (item) {
                    if (!item.hidden) {
                        legendItems = legendItems.concat([].slice.call(item.classList));
                    }
                });



              if (itemsList.length < 1) {
                    //no trials at all. set smaller grid class
                    currentYear.classList.add('small-grid');
                } else {
                    let allHidden = true;
                    itemsList = [].slice.call(itemsList);
                    itemsList.forEach(function (item) {
                        if (!item.hidden) {
                            allHidden = false;
                        }
                    })

                    if (allHidden) {
                        //set class
                        currentYear.classList.add('small-grid');
                    }
                }
                this.legendItems = legendItems;
            },
            setClassName: function(month) {
                if(month === 2) {
                    return 'days-28';
                } else if( this.middleMonth.indexOf(month) > -1) {
                    return 'days-30';
                } else {
                    return '';
                }
            },
            setToday: function() {
                try {
                    this.setGrids();
                } catch (e) {
                    // Current year grid may be missing when no trials exist
                }

                let marker = document.getElementById('today-marker');
                if( marker === null) {
                    let d = new Date();
                    let days = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
                    let monthPercent = d.getDate() / days * 100;

                    let selector = this.months[d.getMonth()];
                    let div = document.createElement('div');
                    div.setAttribute('id', 'today-marker');
                    div.classList.add('is-today-marker');
                    div.style.left = monthPercent + '%';

                    let sel = document.querySelector('[data-month="' + selector + '"]');
                    if (sel) {
                        sel.appendChild(div);
                    }
                }

                this.$nextTick(() => {
                    this.lockTodayPosition();
                });
            },
            clearTodaySnap: function() {
                if (this._todaySnapInterval) {
                    clearInterval(this._todaySnapInterval);
                    this._todaySnapInterval = null;
                }
                if (this._todaySnapTimeout) {
                    clearTimeout(this._todaySnapTimeout);
                    this._todaySnapTimeout = null;
                }
            },
            lockTodayPosition: function() {
                this.clearTodaySnap();
                this.sizeTimeline();
                this.centerToday();

                const timeline = document.querySelector('.timeline');
                if (!timeline) {
                    return;
                }

                let lastWidth = timeline.scrollWidth;
                this._todaySnapInterval = setInterval(() => {
                    const overflow = timeline.scrollWidth > timeline.clientWidth + 1;
                    const atStart = timeline.scrollLeft < 2;
                    if (timeline.scrollWidth !== lastWidth || (overflow && atStart)) {
                        lastWidth = timeline.scrollWidth;
                        this.centerToday();
                    }
                }, 50);

                this._todaySnapTimeout = setTimeout(() => {
                    this.clearTodaySnap();
                    this.centerToday();
                }, 1500);
            },
            setObserver: function(element) {
                const vm = this;
                this.intersectionOb = new IntersectionObserver(function(entries){
                    if(entries[0].intersectionRatio > 0){
                        vm.todayInView = true;
                        //vm.intersectionOb.unobserve(element);
                    } else {
                        vm.todayInView = false;
                    }
                    // console.log(entries[0]);
                    // console.log(vm.todayInView);
                })

                this.intersectionOb.observe(element);
            },
            setMoaModal: function() {
                this.moaModalProduct = this.$route.params.filtertype === 'product' ? this.$route.params.filtervalue : false;

            },
            setMoaModalByEvent: function(value) {
                //if(this.$route.params.filtertype !== 'product') {
                    this.moaModalProduct = value;
                //} else {
                //}
            },
            canDisplayProduct: function(productId) {

                var notAllowedItems = window.localStorage.getItem('storageProducts'); 

                if(notAllowedItems !== null){
                    var notAllowed = JSON.parse(notAllowedItems); 
                    
                    if(notAllowed.length > 0)
                    {
                        let idIsString = productId.toString(); 
                        if(notAllowed.indexOf(idIsString) > -1)
                        {
                            //console.log('inarray');
                            return false; 
                        }
                    } else {
                        return true; 
                    }
                } 

                return true;
            },
            filterTitleChange: function(str) {
                this.pageTitle = str;
            },
            getlink: function(targetId){
                return '/trials-two/'+targetId;
            },
            placeTodayMarker: function() {
                /* get month and year details */
                let today = new Date(); 
                var year = today.getFullYear(); 
                var month = today.getMonth(); 
                /* work out month as percentage of the year */
                var percent = (month / 11) * 100; 
                
                /* select the relevant element */
                var targetEl = document.querySelector('[data-yeargroup="'+ year +'"]');
                
                /* create the 'today' item, add position left value and append to the 
                    relevant part of the page 
                */
                var listItem = document.createElement('li'); 
                listItem.classList.add('today'); 
                listItem.setAttribute('id', 'today-marker'); 
                listItem.textContent = 'Today'; 
                listItem.style.left = percent+'%'; 
                if(targetEl !== null){
                    targetEl.appendChild(listItem); 
                }

                this.centerToday();
                
                return true;
            }, 
            getTimelineEl: function() {
                return this.$refs.timelineEl || document.querySelector('.timeline');
            },
            sizeTimeline: function() {
                const timeline = this.getTimelineEl();
                if (!timeline) {
                    return;
                }

                ['.content-container', '.timeline-shell', '.content-container > .container'].forEach(function(selector) {
                    const node = document.querySelector(selector);
                    if (!node) {
                        return;
                    }
                    node.style.removeProperty('width');
                    node.style.removeProperty('max-width');
                    node.style.setProperty('width', '100%', 'important');
                    node.style.setProperty('max-width', '100%', 'important');
                    node.style.setProperty('min-width', '0', 'important');
                });

                const parent = timeline.parentElement;
                const width = Math.round((parent && parent.clientWidth) || document.documentElement.clientWidth || window.innerWidth);
                if (width > 1) {
                    timeline.style.setProperty('width', width + 'px', 'important');
                    timeline.style.setProperty('max-width', '100%', 'important');
                    timeline.style.setProperty('min-width', '0', 'important');
                }

                timeline.style.setProperty('overflow-x', 'auto', 'important');
                timeline.style.setProperty('overflow-y', 'auto', 'important');
                timeline.style.setProperty('touch-action', 'pan-x', 'important');
                timeline.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
                this.syncTimelineScrollbar();
            },
            bindTimelinePan: function() {
                const timeline = this.getTimelineEl();
                if (!timeline || this._timelinePanBound) {
                    return;
                }
                this._timelinePanBound = true;
                this._onTimelinePanStart = function(event) {
                    if (!event.touches || event.touches.length !== 1) {
                        return;
                    }
                    this._panX = event.touches[0].pageX;
                    this._panScroll = timeline.scrollLeft;
                    this._panning = true;
                }.bind(this);
                this._onTimelinePanMove = function(event) {
                    if (!this._panning || !event.touches || event.touches.length !== 1) {
                        return;
                    }
                    const maxScroll = Math.max(0, timeline.scrollWidth - timeline.clientWidth);
                    if (maxScroll < 1) {
                        return;
                    }
                    if (event.cancelable) {
                        event.preventDefault();
                    }
                    timeline.scrollLeft = this._panScroll + (this._panX - event.touches[0].pageX);
                    this.syncTimelineScrollbar();
                }.bind(this);
                this._onTimelinePanEnd = function() {
                    this._panning = false;
                }.bind(this);
                timeline.addEventListener('touchstart', this._onTimelinePanStart, { passive: true });
                timeline.addEventListener('touchmove', this._onTimelinePanMove, { passive: false });
                timeline.addEventListener('touchend', this._onTimelinePanEnd, { passive: true });
                timeline.addEventListener('touchcancel', this._onTimelinePanEnd, { passive: true });
            },
            unbindTimelinePan: function() {
                const timeline = this.getTimelineEl();
                this._timelinePanBound = false;
                this._panning = false;
                if (!timeline) {
                    return;
                }
                if (this._onTimelinePanStart) {
                    timeline.removeEventListener('touchstart', this._onTimelinePanStart);
                }
                if (this._onTimelinePanMove) {
                    timeline.removeEventListener('touchmove', this._onTimelinePanMove);
                }
                if (this._onTimelinePanEnd) {
                    timeline.removeEventListener('touchend', this._onTimelinePanEnd);
                    timeline.removeEventListener('touchcancel', this._onTimelinePanEnd);
                }
            },
            syncTimelineScrollbar: function() {
                const timeline = this.getTimelineEl();
                const track = this.$refs.timelineHScroll;
                if (!timeline) {
                    return;
                }
                this.timelineMetrics = {
                    scrollLeft: timeline.scrollLeft,
                    scrollWidth: timeline.scrollWidth || 1,
                    clientWidth: timeline.clientWidth || 1,
                    trackWidth: track ? (track.clientWidth || 1) : (timeline.clientWidth || 1)
                };
            },
            eventClientX: function(event) {
                if (event.touches && event.touches[0]) {
                    return event.touches[0].clientX;
                }
                if (event.changedTouches && event.changedTouches[0]) {
                    return event.changedTouches[0].clientX;
                }
                return event.clientX;
            },
            setTimelineScrollFromClientX: function(clientX) {
                const track = this.$refs.timelineHScroll;
                const timeline = this.getTimelineEl();
                if (!track || !timeline) {
                    return;
                }
                const rect = track.getBoundingClientRect();
                const overflow = Math.max(timeline.scrollWidth - timeline.clientWidth, 0);
                if (overflow < 1 || rect.width < 1) {
                    return;
                }
                const thumbWidth = Math.max(48, (timeline.clientWidth / timeline.scrollWidth) * rect.width);
                const maxLeft = Math.max(rect.width - thumbWidth, 0);
                let left = clientX - rect.left - thumbWidth / 2;
                left = Math.min(Math.max(left, 0), maxLeft);
                timeline.scrollLeft = maxLeft < 1 ? 0 : (left / maxLeft) * overflow;
            },
            onScrollbarPointerDown: function(event) {
                this._scrollbarDragging = true;
                this.setTimelineScrollFromClientX(this.eventClientX(event));
                this._onScrollbarMove = this.onScrollbarPointerMove.bind(this);
                this._onScrollbarUp = this.onScrollbarPointerUp.bind(this);
                document.addEventListener('mousemove', this._onScrollbarMove);
                document.addEventListener('mouseup', this._onScrollbarUp);
                document.addEventListener('touchmove', this._onScrollbarMove, { passive: false });
                document.addEventListener('touchend', this._onScrollbarUp);
            },
            onScrollbarPointerMove: function(event) {
                if (!this._scrollbarDragging) {
                    return;
                }
                if (event.cancelable) {
                    event.preventDefault();
                }
                this.setTimelineScrollFromClientX(this.eventClientX(event));
            },
            onScrollbarPointerUp: function() {
                this._scrollbarDragging = false;
                this.unbindScrollbarPointer();
            },
            unbindScrollbarPointer: function() {
                if (this._onScrollbarMove) {
                    document.removeEventListener('mousemove', this._onScrollbarMove);
                    document.removeEventListener('touchmove', this._onScrollbarMove);
                    this._onScrollbarMove = null;
                }
                if (this._onScrollbarUp) {
                    document.removeEventListener('mouseup', this._onScrollbarUp);
                    document.removeEventListener('touchend', this._onScrollbarUp);
                    this._onScrollbarUp = null;
                }
            },
            centerToday: function(){
                this.sizeTimeline();
                const timeline = document.querySelector('.timeline');
                const marker = document.getElementById('today-marker');
                if (!timeline) {
                    return;
                }

                const previousBehavior = timeline.style.scrollBehavior;
                timeline.style.scrollBehavior = 'auto';

                const maxScroll = Math.max(0, timeline.scrollWidth - timeline.clientWidth);

                if (marker) {
                    const timelineRect = timeline.getBoundingClientRect();
                    const markerRect = marker.getBoundingClientRect();
                    const scale = timelineRect.width ? (timeline.clientWidth / timelineRect.width) : 1;
                    const markerLeft = (markerRect.left - timelineRect.left) * scale + timeline.scrollLeft;
                    const edgePad = Math.min(timeline.clientWidth * 0.28, 220);
                    const target = Math.max(0, Math.min(markerLeft - timeline.clientWidth + edgePad, maxScroll));
                    if (typeof timeline.scrollTo === 'function') {
                        timeline.scrollTo(target, 0);
                    } else {
                        timeline.scrollLeft = target;
                    }
                } else if (typeof timeline.scrollTo === 'function') {
                    timeline.scrollTo(maxScroll, 0);
                } else {
                    timeline.scrollLeft = maxScroll;
                }

                timeline.style.scrollBehavior = previousBehavior;
            },
            sortResults: function(results) {

                results = results.sort(function(a,b) {
                        if( a.year < b.year){
                            return -1; 
                        } else {
                            return 1; 
                        }
                });

                for(var i = 0; i < results.length; i++) {

                    results[i].data = results[i].data.sort( function(a,b) {
                        if( a.month < b.month){
                            return -1; 
                        } else {
                            return 1; 
                        }
                    }); 

                    for(var j = 0; j < results[i].data.length; j++ ) {
                        results[i].data[j].data = results[i].data[j].data.sort(function(a,b) {
                            if( a.day < b.day){
                                return -1; 
                            } else {
                                return 1; 
                            }
                        }); 
                       
                    }
                }

                return results;

            },
            createMonthsObject: function() {

                let arr = [];

                for(let month = 1; month < 13; month++) {
                    let o = {
                        month: month,
                        data: [],
                    }
                    arr.push(o);
                }

                return arr;
            },
            createCurrentYear: function() {
                let d = new Date();
                let o = {
                    year: d.getFullYear(),
                    data: this.createMonthsObject()
                }
                return o;

            },
            filterItemsByDate: function() {
                /**
                * group all products in to new array with date keys so we can display in date order
                */

                //let items = this.$store.getters.allProducts;
                let items = this.products;
                var results = [];  
                var vm = this; 
                // let itemIndex = 0;

                items.forEach(function(item) {
                    //console.log(Object.keys(item).length);
                    
                    if(item.type[0].target_id == 'page'){
                                      
                        if (vm.canDisplayProduct(item.field_product_list[0].target_id) ) {
                            let dateMarker = item.field_trial_completion_date[0].value; 

                            let splitDate = dateMarker.split('-'); 

                            let year = parseInt(splitDate[0]); //year 
                            let month = parseInt(splitDate[1]); 
                            let day = parseInt(splitDate[2]); 

                            var thisYear = null; 
                            for( let i=0; i < results.length; i++){

                                if(results[i].year == year) {
                                    thisYear = results[i]; 
                                }

                                
                            }

                            if(thisYear === null) {
                                let d = new Date();
                                if (year == d.getFullYear()) {
                                    thisYear = {
                                        year: year,
                                        data: vm.createMonthsObject()
                                    };
                                } else {
                                    thisYear = {
                                       year: year,
                                        data: []
                                    }
                                }

                                results.push(thisYear);
                            }

                            var thisMonth = null; 
                            for(var m = 0; m< thisYear.data.length; m++) {
                                if(thisYear.data[m].month == month) {
                                    thisMonth = thisYear.data[m]; 
                                }
                            }

                            if(thisMonth === null) {
                                    thisMonth = {
                                        month: month,
                                        data: [] 
                                    }

                                    thisYear.data.push(thisMonth); 
                                }

                            var thisDay = null; 
                            for(var n = 0; n< thisMonth.data.length; n++) {
                                
                                if(thisMonth.data[n].day == day)
                                {
                                    thisDay = thisMonth.data[n]; 
                                }

                                
                            }

                            if (thisDay === null) {
                                thisDay = {
                                    day: day,
                                    data: []
                                }

                                thisMonth.data.push(thisDay);
                            }

                            thisDay.data.push(item); 
                        }
                    }
                });

                if(results.length > 0) {
                    this.itemsToShow = true;
                    let yr = (new Date()).getFullYear();
                    let yearExists = false; 
                    results.forEach(function(result){

                        if(result.year == yr) {
                            yearExists = true;
                        }

                    })

                    if(!yearExists) {

                        let o = vm.createCurrentYear();
                        results.push(o); 
                    }
             

                } else {
                    this.itemsToShow = false; 
                }

                
                
                return this.sortResults(results);
                
            },
            getDiseaseStateClassName: function(targetId) {
                let finalClass = ''; 

                if(targetId == '')
                {
                    return ''; 
                }
               
                let diseaseStates = this.$store.getters.getDiseaseStates; 
                let filtered = diseaseStates.filter( el => {
                    return el.tid[0].value == targetId;
                });

                // Abort if no diseaseState with targetId is found 
                if (!filtered[0]) {
                    return finalClass;
                }

                if(filtered[0].parent[0].target_id === null) {
                    finalClass += filtered[0].name[0].value;  
                } else {
                    let extraFilter = diseaseStates.filter( el => el.tid[0].value == filtered[0].parent[0].target_id); 
                    finalClass += extraFilter[0].name[0].value; 
                }
                
                return finalClass; 
            },
            getTrackingLabelData: function(item) {
                const phase = this.getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value');
                const product = this.getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value');
                return `${phase} ${product}`;
            },
            trackEvent: function(event) {
                this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
            },
            onAccepted: function() {
                this.disclaimerParams = null;
            }
        }
    }
</script>

<style>
    .small-grid {
        grid-template-columns: repeat(12, 0.1fr);

    }

    .timeline-shell {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        min-height: 0;
    }

    .timeline::-webkit-scrollbar {
        display: none !important;
        height: 0 !important;
        width: 0 !important;
    }

    .timeline-h-scroll {
        position: fixed;
        left: 24px;
        right: 24px;
        bottom: 4.6em;
        z-index: 15;
        flex: 0 0 16px;
        height: 16px;
        margin: 0;
        background: #d9d9d9;
        border-radius: 10px;
        cursor: pointer;
        overflow: hidden;
        touch-action: none;
    }

    .timeline-h-scroll-thumb {
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: 0;
        min-width: 48px;
        background: #003B33;
        border-radius: 10px;
        cursor: grab;
        will-change: transform;
    }
</style>
